import styled from "styled-components";

export const ContainerLogin = styled.div`
    padding-top: 7%;

    .title{
        background-color: #F5A796;
        color: #232323;
        height: 40px;
        font-size: 1.5rem;
        font-weight: 500;
    }

    .container {
        padding: 2% 15%;
        display: flex;
        flex-direction: column;
        item-align: center;
        justify-content: center;
        text-align: left;
    }

    .btn-iniciar{
        height: 70px ;
        display:flex;
        justify-content: center ;
        align-items: center;

    }
`;

export const TextValidation = styled.span`
    font-size: 9px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    color:red;
    padding:0px;
    margin:0px;
`;

